<div class="appImage" [ngClass]="ratio">
  <img [lazyLoad]="src" [alt]="alt" *ngIf="!zoom" style="object-fit: contain;" />
  <lib-ngx-image-zoom
    [thumbImage]="src"
    [fullImage]="src"
    [zoomMode]="'hover'"
    *ngIf="zoom"
  ></lib-ngx-image-zoom>
</div>
